<script lang="ts">
import { sanitizeEmbedHtml } from '$lib/utils/sanitise';

let {
    iframeCode = '',
    aspectRatio = '16/9',
    aspectRatioMobile = '1/2',
    iframeCodeMobile = '',
    hideBlock = false,
} = $props();

const sanitisedIframeCode = $derived(sanitizeEmbedHtml(iframeCode));
const sanitisedIframeCodeMobile = $derived(sanitizeEmbedHtml(iframeCodeMobile));
</script>

{#if !hideBlock}
    <div class="iframe" style="--aspect-ratio: {aspectRatio}; --aspect-ratio-mobile: {aspectRatioMobile}">
        {#if sanitisedIframeCodeMobile}
            <div class="iframe__container iframe__container--mobile">
                {@html sanitisedIframeCodeMobile}
            </div>
            <div class="iframe__container iframe__container--desktop">
                {@html sanitisedIframeCode}
            </div>
        {:else}
            {@html sanitisedIframeCode}
        {/if}
    </div>
{/if}

<style lang="scss">
    @use 'sass-mq/mq' as *;

    .iframe {
        aspect-ratio: var(--aspect-ratio-mobile);
        padding-left: var(--layout-pagegrid-margin);
        padding-right: var(--layout-pagegrid-margin);

        @include mq($from: tablet) {
            aspect-ratio: var(--aspect-ratio);
        }

        :global(iframe) {
            width: 100%;
            height: 100%;
        }

        &__container {
            width: 100%;
            height: 100%;
            
            &--mobile {
                display: block;

                @include mq($from: tablet) {
                    display: none;
                }
            }

            &--desktop {
                display: none;

                @include mq($from: tablet) {
                    display: block;
                }
            }
        }
    }
</style>
